const EVENT_SINGLE_URL = "/v1/calendar/single";
const EVENT_LIST_URL = "/v1/calendar/list";
const EVENT_ADD_URL = "/v1/calendar/add";
const EVENT_UPDATE_URL = "/v1/calendar/update";
const EVENT_DELETE_URL = "/v1/calendar/delete";
const CATEGORY_LIST_URL = "/v1/calendar/category-list";
const CATEGORY_SINGLE_URL = "/v1/calendar/category-single";
const CATEGORY_ADD_URL = "/v1/calendar/category-add";
const CATEGORY_UPDATE_URL = "/v1/calendar/category-update";
const CATEGORY_DELETE_URL = "/v1/calendar/category-delete";

const CALENDAR_API_URL_LIST = {
    EVENT_SINGLE_URL,
    EVENT_LIST_URL,
    EVENT_ADD_URL,
    EVENT_UPDATE_URL,
    EVENT_DELETE_URL,
    CATEGORY_LIST_URL,
    CATEGORY_SINGLE_URL,
    CATEGORY_ADD_URL,
    CATEGORY_UPDATE_URL,
    CATEGORY_DELETE_URL
}

export { CALENDAR_API_URL_LIST };
